import gql from 'graphql-tag';

export default gql`
  mutation(
    $publicationUrl: URI!
    $suggestionsListId: ID!
    $bookings: Int!
    $maxSimultaneous: Int!
  ) {
    addHighDemandSuggestion(
      input: {
        publicationUrl: $publicationUrl
        suggestionsListId: $suggestionsListId
        libraryComment: ""
        bookings: $bookings
        maxSimultaneous: $maxSimultaneous
      }
    ) {
      code
    }
  }
`;
